export const MotClef = {
    Cotisation: 'COTISATION',
    Pension:'PENSION',
    CapitalRetraite:'CAPITAL RETRAITE',
    Beneficiaire: 'BENEFICIAIRE',
};
